import React, { useState } from 'react'
import moment from 'moment'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Menu, MenuItem, Modal } from '@mui/material'
import AccessLogs from '../EPCRView/AccessLogs'
import Age from '../../../../components/Age'

const Header = ({ record, setOpenEdits }) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const [showAccessLogs, setShowAccessLogs] = useState(false)

  return (
    <EPCRCard>
      <Stack>
        <Stack direction="row" gap={1} justifyContent="space-between">
          <Typography fontWeight={900}>{record?.pcrNumber || ''}</Typography>
          <Typography>{`${
            record?.demographics?.lastName
              ? record?.demographics?.lastName + ','
              : ''
          } ${
            record?.demographics?.firstName
              ? record?.demographics?.firstName[0]
              : ''
          } ${
            record?.demographics?.dob
              ? Age(record.demographics.dob, record?.createdAt)
              : ''
          }`}</Typography>
          <Stack gap={1} direction="row">
            <Tooltip
              title={
                <Stack alignItems="center">
                  <Typography variant="caption">Created By</Typography>
                  <Typography fontWeight="bold">
                    {record.completedBy.userAccount.firstName +
                      ' ' +
                      record.completedBy.userAccount.lastName}
                  </Typography>
                </Stack>
              }
            >
              <Avatar
                src={record.completedBy.userAccount.photograph}
                sx={{ borderRadius: 1, width: 24, height: 24 }}
              />
            </Tooltip>
            <Tooltip
              title={
                <Stack alignItems="center">
                  <Typography variant="caption">Uploaded By</Typography>
                  <Typography fontWeight="bold">
                    {record.uploadedBy.userAccount.firstName +
                      ' ' +
                      record.uploadedBy.userAccount.lastName}
                  </Typography>
                </Stack>
              }
            >
              <Avatar
                src={record.uploadedBy.userAccount.photograph}
                sx={{ borderRadius: 1, width: 24, height: 24 }}
              />
            </Tooltip>
            <Chip
              sx={{ borderRadius: 1 }}
              color={
                record?.review?.status === 'Draft'
                  ? 'error'
                  : record?.review?.status === 'Submitted'
                  ? 'success'
                  : 'info'
              }
              label={record?.review?.status ?? 'Submitted'}
              size="small"
            />
            <MoreVertIcon
              onClick={(e) => setMenuAnchorEl(e.currentTarget)}
              sx={{ cursor: 'pointer' }}
            />
          </Stack>
        </Stack>
      </Stack>
      <Menu
        open={!!menuAnchorEl}
        onClose={() => setMenuAnchorEl(null)}
        anchorEl={menuAnchorEl}
      >
        <MenuItem onClick={() => setShowAccessLogs(true)}>
          Show Access Logs
        </MenuItem>
        <MenuItem onClick={() => setOpenEdits(true)}>Edit Record</MenuItem>
      </Menu>

      <AccessLogs
        paperPCRID={record._id}
        open={showAccessLogs}
        onClose={() => setShowAccessLogs(false)}
      />
    </EPCRCard>
  )
}

export default Header
